import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createEnterpriseLeadRequest = {};
var _createEnterpriseLeadResponse = {};
function resolveWixApiFunnelIntroHydraEnterpriseLeadServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/funnel-intro-hydra-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/funnel-intro-hydra-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/funnel-intro-hydra-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Create a new enterprise lead */
export function createEnterpriseLead(payload) {
    var _a = serializer(_createEnterpriseLeadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createEnterpriseLeadResponse, {}).fromJSON;
    function __createEnterpriseLead(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_intro.v1.enterprise_lead',
            method: 'POST',
            methodFqn: 'wix.api.funnel.intro.hydra.EnterpriseLeadService.CreateEnterpriseLead',
            url: resolveWixApiFunnelIntroHydraEnterpriseLeadServiceUrl({
                protoPath: '/v1/enterprise-leads',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createEnterpriseLead.fromReq = fromReq;
    __createEnterpriseLead.__isAmbassador = true;
    return __createEnterpriseLead;
}
//# sourceMappingURL=http.impl.js.map